// auto-generated by scripts/generate-version.js — do not edit
export const APP_VERSION = '0.3.0-4bedb06';
